(function () {
	function updateDefaultContent() {
		const $input = $("#search-modal").find(".search__input");
		const hasValue = $input.val() && $input.val().trim() !== "";

		if (hasValue) {
			$(".search-modal__default-content").hide();
		} else {
			$(".search-modal__default-content").show();
		}
	}

	function searchToggle() {
		$("#search-modal, .search-modal__mask").toggleClass("active");

		if ($("#search-modal").hasClass("active")) {
			$("#search-modal").find(".search__input").focus();
			updateDefaultContent();
		} else {
			$(".search-modal-trigger").focus();
		}

		$("body").toggleClass("overflow-hidden");
	}

	function bindSearchModalEvents() {
		$(document).on("click", ".search-modal-trigger, .search-modal__mask, .search-modal__close", function (e) {
			e.preventDefault();
			searchToggle();
		});

		$(document).on("input", "#search-modal .search__input", function () {
			updateDefaultContent();
		});

		$(document).on("click", "#search-modal .reser-search", function () {
			setTimeout(function () {
				updateDefaultContent();
			}, 0);
		});
	}

	$(document).on("keyup", function (e) {
		if ($("#search-modal").hasClass("active") && e.key === "Escape") {
			searchToggle();
		}
	});

	document.addEventListener("shopify:section:load", function () {
		updateDefaultContent();
	});

	bindSearchModalEvents();
})();